<template>
  <div>
    <div id="openst-mini-map" style="width: 100%; height: 200px;"></div>
    <!-- Modal for expanded map -->
    <div v-if="isExpanded" class="map-modal">
      <div class="map-modal-content">
        <div id="expanded-map" style="width: 100%; height: 80vh;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: '/vstatic/js/leaflet/images/marker-icon.png',
  iconRetinaUrl: '/vstatic/js/leaflet/images/marker-icon-2x.png',
  shadowUrl: '/vstatic/js/leaflet/images/marker-shadow.png',
});

export default {
  props: {
    // [{lat: float, long: float, name: str, address: str}]
    locations: [],
    selectedLocation: {},
  },
  data() {
    return {
      map: null,
      expandedMap: null,
      defZoomLevel: 3,
      isExpanded: false,
      selectedView: null,
      storeMapParams: null,
    };
  },
  watch: {
    locations: {
      handler(newLocations) {
        this.selectedView = null
        this.loadMaps();
      },
      deep: true,
    },
  },
  mounted() {
    // this.loadMaps()
  },
  destroyed() {
    if(this.map){
      this.map.off();
      this.map.remove();
    }
    if(this.expandedMap){
      this.expandedMap.off();
      this.expandedMap.remove();
    }
  },
  methods: {
    currentMapParams(){
      let map = null
      if(this.isExpanded && this.expandedMap){
        map = this.expandedMap
      }
      if(!this.isExpanded && this.map){
        map = this.map
      }
      if(!map) return null
      const center = map.getCenter()
      return {'lat': center.lat, 'long': center.lng, 'zoom': map.getZoom()}
    },
    selectSetView(data){
      if(!this.map) return;
      if(!data.lat && !data.long) return;
      this.selectedView = {...data}
      this.map.setView([data.lat, data.long], this.map.getZoom());
    },
    expandMap() {
      this.storeMapParams = this.currentMapParams()
      this.isExpanded = true;
      this.$nextTick(() => {
        this.loadExpandedMap();
      });
    },
    shrinkMap() {
      this.storeMapParams = this.currentMapParams()
      this.isExpanded = false;
      if(this.expandedMap) {
        this.expandedMap.remove();
        this.expandedMap = null;
      }
      if(this.map && this.storeMapParams){
        this.map.setView([this.storeMapParams.lat, this.storeMapParams.long], this.storeMapParams.zoom)
      }
    },
    createExpandControl() {
      const ExpandControl = L.Control.extend({
        options: {
          position: 'topright'
        },
        onAdd: () => {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
          const button = L.DomUtil.create('button', '', container);
          button.innerHTML = '<i class="fas fa-expand"></i>';
          button.style.cssText = 'width: 30px; height: 30px; line-height: 30px; text-align: center; background: white; border: 2px solid rgba(0,0,0,0.2); border-radius: 4px; cursor: pointer;';
          
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.on(button, 'click', L.DomEvent.stop)
            .on(button, 'click', this.expandMap, this);
            
          return container;
        }
      });
      return new ExpandControl();
    },
    createShrinkControl() {
      const ShrinkControl = L.Control.extend({
        options: {
          position: 'topright'
        },
        onAdd: () => {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
          const button = L.DomUtil.create('button', '', container);
          button.innerHTML = '<i class="fas fa-compress"></i>';
          button.style.cssText = 'width: 30px; height: 30px; line-height: 30px; text-align: center; background: white; border: 2px solid rgba(0,0,0,0.2); border-radius: 4px; cursor: pointer;';
          
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.on(button, 'click', L.DomEvent.stop)
            .on(button, 'click', this.shrinkMap, this);
            
          return container;
        }
      });
      return new ShrinkControl();
    },
    getSelectedView() {
      if(this.storeMapParams){
        return {...this.storeMapParams}
      }
      if(this.selectedView) {
        return {...this.selectedView};
      }
      return this.locations.find(loc => loc.lat && loc.long);
    },
    initializeMap(mapId, control) {
      const map = L.map(mapId).setView([51.5, -0.1], this.defZoomLevel);
      
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: 'OpenStreetMap'
      }).addTo(map);

      if(control) {
        control.addTo(map);
      }

      const selectedView = this.getSelectedView();
      if(selectedView) {
        map.setView([selectedView.lat, selectedView.long], selectedView.zoom ? selectedView.zoom : this.defZoomLevel);
      }

      this.locations.forEach(loc => {
        if(loc.lat && loc.long){
          L.marker([loc.lat, loc.long])
            .addTo(map)
            .bindPopup(`<b>${loc.name}</b><br>${loc.address}`);
        }
      });

      return map;
    },
    loadExpandedMap() {
      if(this.expandedMap) {
        this.expandedMap.remove();
      }
      this.expandedMap = this.initializeMap("expanded-map", this.createShrinkControl());
    },
    loadMaps(){
      if(this.map){
        this.map.remove();
      }
      this.map = this.initializeMap("openst-mini-map", this.createExpandControl());
    },
  }
}
</script>

<style scoped>
.map-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.map-modal-content {
  position: relative;
  width: 90%;
  height: 90%;
  background: white;
  border-radius: 8px;
  padding: 20px;
}
</style>
